<template>
  <v-dialog
    v-model="dialog"
    max-width="320px"
    content-class="lb-time-dialog"
    transition="dialog-transition"
    data-testid="time__dialog"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-text-field
        ref="element"
        dense
        outlined
        :label="hideLabel ? '' : (label || 'Time')"
        clearable
        v-bind="attrs"
        v-on="on"
        :readonly="readonly"
        :class="{ 'lb-time-field--readonly': readonly }"
        :error-messages="error"
        :value="formattedRangevalue"
        :hide-details="hidedetails"
        :disabled="disabled"
        @click:clear="setBlank(); updateValue()"
        @keydown.native="blockTypedTime"
        @paste.native="blockPastedTime"
        data-testid="time__textfield"
      ></v-text-field>
    </template>

    <v-time-picker
      v-model="tempContent"
      full-width
      color="caccounting"
      scrollable
      data-testid="time__picker"
    >
      <v-spacer data-testid="time__spacer"></v-spacer>
      <v-btn text @click="dialog = false; tempContent = content; updateValue()" data-testid="time__close-btn">
        <span data-testid="time__close-label">Close</span>
      </v-btn>
      <v-btn elevation="0" color="primary" @click="content = tempContent; dialog = false; updateValue()" data-testid="time__ok-btn">
        <span data-testid="time__ok-label">OK</span>
      </v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
import constants from '@/plugins/constants';

export default {
  data: () => ({
    dialog: false,
    content: "",
    tempContent: ""
  }),
  props: {
    error: [String, Array],
    label: String,
    value: String,
    hidedetails: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    hideLabel: { type: Boolean, default: false },
    /** Clock sets the value. Typed characters, including letters, are ignored. */
    readonly: { type: Boolean, default: false },
  },
  methods: {
    blockTypedTime(event) {
      if (!this.readonly || event.ctrlKey || event.metaKey) return;
      if (constants.READONLY_TIME_INPUT_ALLOWED_KEYS.includes(event.key)) return;
      event.preventDefault();
    },
    blockPastedTime(event) {
      if (this.readonly) event.preventDefault();
    },
    setValue() {
      this.content = this.value || "";
      this.tempContent = this.content;
    },
    updateValue() {
      this.content = this.tempContent;  // Ensure content updates correctly
      this.$emit("input", this.content);
      this.$emit("change", this.content);
    },
    setFocus() {
      this.$nextTick(() => {
        this.$refs.element?.$el.querySelector("input")?.focus();
      });
    },
    setBlank() {
      this.content = "";
      this.tempContent = "";
    }
  },
  computed: {
    formattedRangevalue() {
      return this.content ? this.$nova.formatTime(this.content) : "";
    }
  },
  watch: {
    dialog(open) {
      if (open) this.tempContent = this.content;
    },
    value(newVal) {
      this.setValue();
      if (!newVal) this.setBlank();
    }
  },
  created() {
    this.setValue();
  }
};
</script>

<style lang="scss">
/* Keep Vuetify's dark header + clock. Only undo global `* { font-size: 1rem }`
   so hour/minute digits in the title stay readable. */
.lb-time-field--readonly input {
  cursor: pointer;
}

.lb-time-dialog {
  .v-picker__title {
    overflow: visible;
    height: auto !important;
  }

  .v-time-picker-title__time,
  .v-time-picker-title__time * {
    font-size: 56px !important;
    line-height: 1 !important;
    height: auto !important;
  }

  .v-time-picker-title__ampm,
  .v-time-picker-title__ampm * {
    font-size: 16px !important;
    line-height: 1.2 !important;
    height: auto !important;
  }
}
</style>
